module.exports = __webpack_public_path__ + "media/images/lb/222-9ac3c39dd35ebf83d29ef416f261a74b.svg";